import React from "react";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { X } from "lucide-react";

const ReviewAndFinish = ({
  id_R,
  closeReviewModal,
  handleNextButtonClick,
  reviewModalOpen,
  openUserInfoModal,
  openModal,
  openRolesModal,
  firstName,
  lastName,
  email,
  userName,
  jobTitle,
  department,
  selectedRole,
}) => {
  const handleBackButtonClick = () => {
    // Close the current modal
    closeReviewModal();

    // Open the previous modal
    openUserInfoModal();
  };

  const handleEditRole = () => {
    // Close the current modal
    closeReviewModal();

    openRolesModal();
  };

  const handleEditCustomer = () => {
    // Close the current modal
    closeReviewModal();

    openModal();
  };
  return (
    <>
      <div
        id={id_R}
        className={`${
          reviewModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative rounded-[10px] flex h-[550px] w-[1080px] bg-white shadow">
          <div
            onClick={closeReviewModal}
            className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
          >
            <X color="#ffffff" />
          </div>
          <div className="flex w-full mx-auto">
            <div className="w-[28%] p-[20px] rounded-[10px] bg-[#F5F6F7]">
              <div className="rounded-t">
                <p className="text-[20px] mb-[15px] font-bold text-[#000]">
                  Add user
                </p>
              </div>
              <div>
                <ProgressBar step={4} />
              </div>
            </div>
            <div className="w-[72%] mx-[10px] flex flex-col justify-between">
              <div className="h-[85%] w-[95%]">
                <div className="mt-5 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Review and finish
                  </p>
                  <div className="text-[#000] mt-[20px] text-sm font-normal">
                    <p>
                      Great work! You've provided all the necessary details for
                      the new user. Take a moment to review and confirm the
                      settings below:
                    </p>
                  </div>
                </div>
                <div className="flex justify-between mt-[20px] w-[95%]">
                  <div className="w-[60%]">
                    <div className="">
                      <p className="text-[#000] text-[16px] font-medium">
                        Username and email
                      </p>
                      <p className="text-[#4F4F4F] text-[16px] font-[300]">
                        {firstName} {lastName}
                      </p>
                      <p className="text-[#4F4F4F] text-[16px] font-[300]">
                        {userName}
                      </p>
                      <p className="text-[#4F4F4F] text-[16px] font-[300]">
                        {email}
                      </p>
                    </div>
                    <button
                      onClick={handleEditCustomer}
                      data-modal-toggle={id_R}
                      type="button"
                      className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                    >
                      Edit
                    </button>
                  </div>
                  <div className="w-[40%]">
                    <div className="">
                      <p className="text-[#000] text-[16px] font-medium">
                        Role
                      </p>
                      <p className="text-[#4F4F4F] text-[16px] font-[300]">
                        {selectedRole?.name}
                      </p>
                    </div>
                    <button
                      onClick={handleEditRole}
                      data-modal-toggle={id_R}
                      type="button"
                      className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                    >
                      Edit
                    </button>
                  </div>
                </div>
                <div className="mt-8">
                  <div className="">
                    <p className="text-[#000] text-[16px] font-medium">
                      Additional user information
                    </p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300]">
                      Job Title: {jobTitle}
                    </p>
                    <p className="text-[#4F4F4F] text-[16px] font-[300]">
                      Department: {department}
                    </p>
                  </div>
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-[#157D93] focus:outline-none font-normal text-[15px] py-1.5"
                  >
                    Edit
                  </button>
                </div>
              </div>
              <div className="h-[15%] flex w-[95%] items-center justify-between">
                <div className="flex items-center gap-[20px]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                  <button
                    onClick={closeReviewModal}
                    data-modal-toggle={id_R}
                    type="button"
                    className="text-gray-500 bg-[#D9D9D9] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-[5px] border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>

                <button
                  onClick={handleNextButtonClick}
                  data-modal-toggle={id_R}
                  type="button"
                  className="text-white bg-[#074073] hover:bg-[#074073] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                >
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewAndFinish;
